import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll restoration based on https://reacttraining.com/react-router/web/guides/scroll-restoration.
export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}
